// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"Z7-z"};